import React from 'react';
import '../App.css';
import { services } from '../constants';
import ButtonLink from './ButtonLink';
import Footer from './Footer';

const ServiceCard = ({ service }) => (
  <div className='sm:w-[250px] w-full'>
    <div
      className='w-full green-pink-gradient p-[1px] rounded-[20px]'>
      <div
        className='rounded-[20px] py-5 px-12 min-h-[280px] flex justify-evenly items-center flex-col'
        style={{ background: '#151030' }}>
        <img
          src={service.icon}
          alt='some_icon'
          className='w-16 h-16 object-contain'
        />
        <h3 className='text-white text-[20px] font-bold text-center'>
          {service.title}
        </h3>
      </div>
    </div>
  </div>
);

const About = () => {
  return (
    <div>

    <div className='bg-black h-full w-full text-white sm:flex sm:justify-around about py-12 mt-8 overflow-x-hidden' id='about'>
      <div className='flex flex-col justify-around'>
        <div className='sm:px-16 px-2'>
          <h2 className='text-4xl sm:text-5xl font-extrabold mt-2'>Introduction</h2>
          <p className='mt-3 mb-6 text-[17px] max-w-3xl leading-[30px]'>
  👨‍💻 Hi, I'm Umair Shaikh, a student from Mumbai, IN. I'm currently pursuing my Bachelor of Engineering degree at Rizvi College of Engineering, set to graduate in July 2024. I'm passionate about data analysis, AI, and building scalable backend systems. I am also interested in SAP and ERP systems and am always eager to gain more knowledge and learn continuously.
  
  <br/>
  ✍️ Beyond coding, I enjoy exploring new technologies and languages to expand my skillset.You can also find me exploring rare and vintage treasures at <a className='text-purple-300 hover:text-purple-400 duration-300' href="https://phila4you.carrd.co/" target='_blank'>Phila4you</a>, where I specialize in numismatics.

  <br/>
  🌟 My goal is to establish an organization that supports children who have lost their parents in wars and incidents by providing them with food, shelter, and love. Additionally, I aspire to help and feed poor people around the world, and I am willing to give 100% and work hard to achieve this.
</p>

          <ButtonLink
            url='https://docs.google.com/document/d/1aD5OeayaHUFG7E3ZS_N-pzIRSh_BlqCuryd1b7-ss8s/edit?usp=sharing'
            text='View Resume →'
            padding={`p-3`}
          />

        </div>
        <div className='mt-20 flex justify-center flex-wrap gap-7'>
          {services.map((service) => (
            <ServiceCard service={service} />
          ))}
        </div>
      </div>
    </div>
    <Footer/>
    </div>
  )
}

export default About;